import { type RefSelectProps } from 'antd'
import { type Ref, forwardRef } from 'react'

import { type SingleOrMultipleSelectProps } from '@/components/types'
import { useAvailableDcs } from '@/features/dcs/hooks'
import { type DcEntity, type UserMeExEntity } from '@/libs/api'

import { DcSelect } from './DcSelect'

type Props = SingleOrMultipleSelectProps<number, DcEntity> & {
  tenantKey: string
  authUser: UserMeExEntity
  needDefaultDcId?: boolean
}

/**
 * 所属している拠点から選択するSelect
 */
export const AvailableDcSelect = forwardRef(
  (
    { tenantKey, authUser, ...props }: Props,
    ref: Ref<RefSelectProps> | undefined
  ) => {
    const { data: availableDcs } = useAvailableDcs(tenantKey, authUser)

    return <DcSelect ref={ref} {...props} options={availableDcs} />
  }
)
